import { useContext } from "react";

import { AuthContext } from "@src/components";

function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
